import './EventCheckInOut.scss';
import { getReleaseMeasurements } from '../../CalendarReleaseCapsule/CalendarReleaseCapsuleHelper';
import { eventActivityType, RELEASE_TYPE } from '../../../constants/myBlockMonth';
import { formatNumToTime } from '../../../helpers/timeHelpers';
import { getClassNameForEarlyOrLate } from '../../../pages/MyBlockMonth/myBlockMonthHelper';

interface Props {
    actualView: boolean
    event: any
    eventType: string
    pairingDetails?: any
    segmentLengthPx?: number
}

const EventCheckInOut = ({actualView, event, eventType, pairingDetails, segmentLengthPx}: Props) => {  

    const getCheckInOutLabelClassName = (type: string) => {
        let className = `other-event__${type}`;
        if(type === 'check-in' && event.carryIn && !event.hasStartRelease) return `${className} display-none`;
        if(type === 'check-out' && event.carryOut) return `${className} display-none`; 
        return className; 
    }

    const getCheckInOutTime = (value: number) => {
        return value > 0 ? formatNumToTime(value) : '00:00';
    }

    return (
        eventType === eventActivityType.PAIRING ? 
            <div 
                className="pairing__c-no-layover-time" 
                style={{
                    paddingLeft: `${pairingDetails.releaseWidth}px`, 
                    width: `100%`
                }}
            >
                {!(event.carryIn && !event.hasStartRelease) && ( 
                    <span id={`eventCheckInTime__${event.unique_id}`} className={getClassNameForEarlyOrLate(event.checkIn.deviation, actualView, 'other-event__check-in')}>
                        {pairingDetails.startTime}
                    </span>
                )}
                {!event.carryOut && (
                    <span className={getClassNameForEarlyOrLate(event.checkOut.deviation, actualView, 'other-event__check-out')}>
                        {pairingDetails.endTime}
                    </span>
                )}
            </div> 
        :
            <div 
                className="other-event__c-time" 
                style={{
                    marginLeft: event.hasStartRelease ? `${getReleaseMeasurements(event, RELEASE_TYPE.START_MARGIN_LEFT, 0)}%` : 0, 
                    marginRight: event.hasEndRelease ? `${getReleaseMeasurements(event, RELEASE_TYPE.END_WIDTH, event.release.length-1)}%` : 0
                }}
            >
                <span id={`otherEventCI_${event.unique_id}`} className={getClassNameForEarlyOrLate(event.checkIn.deviation, actualView, getCheckInOutLabelClassName('check-in'))}>
                    {getCheckInOutTime(event.checkIn.value)}
                </span>
                {!(event.activityType === eventActivityType.GDO || event.activityType === eventActivityType.GDO6 || event.activityType === eventActivityType.RESERVE || event.activityType === eventActivityType.TDO || event.activityType === eventActivityType.TDO6) && ( 
                    <span id={`otherEventCO_${event.unique_id}`} className={getClassNameForEarlyOrLate(event.checkOut.deviation, actualView, getCheckInOutLabelClassName('check-out'))}>
                        {getCheckInOutTime(event.checkOut.value)}
                    </span>
                )}
            </div>
    )
}

export default EventCheckInOut;